import React from 'react';

const AlternativeInvestmentsBottomline = () => {
  const benefits = [
    {
      title: "Enhanced Diversification",
      description: "Alternative investments have low correlation with traditional markets, providing portfolio protection during market downturns and reducing overall volatility."
    },
    {
      title: "Superior Risk-Adjusted Returns",
      description: "Alternative strategies like equity long-short and debt AIFs offer potential for superior performance with controlled risk profiles compared to traditional investments."
    },
    {
      title: "Tax Efficiency",
      description: "Many alternative investment structures like Equity AIFs offer significant tax advantages, with the fund handling taxation and distributions being tax-free for individuals."
    },
    {
      title: "Inflation Protection",
      description: "Alternative assets often provide built-in hedges against inflation, helping preserve real purchasing power during inflationary periods."
    }
  ];

  return (
    <div className="w-full bg-gradient-to-br from-[#113262] to-[#1C52A0] py-12 px-8">
      <div className="max-w-6xl w-full mx-auto px-8 sm:px-10 lg:px-8 py-4 md:py-6 lg:py-8">
        <div className="text-center mb-16">
          <h2 className="text-white text-2xl md:text-3xl lg:text-4xl font-bold mb-4">
            Bottomline: Benefits of Alternative Investments
          </h2>
          <div className="w-24 h-1 bg-[#F49611] mx-auto mt-4"></div>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16">
          {benefits.map((benefit, index) => (
            <div key={index} className="relative">
              {/* Decorative number */}
              <div className="absolute -left-8 top-0 text-6xl font-bold text-white opacity-30">
                {index + 1}
              </div>
              
              {/* Content */}
              <div className="relative">
                <div className="flex items-start space-x-4">
                  {/* Vertical line decoration */}
                  <div className="hidden md:block w-1 h-full bg-gradient-to-b from-[#F49611] to-transparent"></div>
                  
                  <div className="flex-1">
                    <h3 className="text-[#F49611] text-xl font-semibold mb-4">
                      {benefit.title}
                    </h3>
                    <p className="text-white/80 text-base leading-relaxed">
                      {benefit.description}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AlternativeInvestmentsBottomline;